export const FOOTER_URLS = {
    pre: {
        other_portals: 'https://www.mapfre.es/otros-portales/',
        privacy: 'https://www.mapfre.es/privacidad/',
        cookie_policy: 'https://www.mapfre.es/politica-de-cookies/',
        normative: 'https://www.mapfre.es/normativa/',
        accessibility: 'https://www.mapfre.es/accesibilidad/',
        warnings: 'https://www.mapfre.es/advertencias/',
        ARCO: 'https://www.mapfre.es/lopd/',
        information_interest: 'https://www.mapfre.es/informacion-de-interes/',
        data_protection: 'https://www.mapfre.es/lopd/'
    },
    pro: {
        other_portals: 'https://www.mapfre.es/otros-portales/',
        privacy: 'https://www.mapfre.es/privacidad/',
        cookie_policy: 'https://www.mapfre.es/politica-de-cookies/',
        normative: 'https://www.mapfre.es/normativa/',
        accessibility: 'https://www.mapfre.es/accesibilidad/',
        warnings: 'https://www.mapfre.es/advertencias/',
        ARCO: 'https://www.mapfre.es/lopd/',
        information_interest: 'https://www.mapfre.es/informacion-de-interes/',
        data_protection: 'https://www.mapfre.es/lopd/'
    },
    int: {
        other_portals: 'https://www.mapfre.es/otros-portales/',
        privacy: 'https://www.mapfre.es/privacidad/',
        cookie_policy: 'https://www.mapfre.es/politica-de-cookies/',
        normative: 'https://www.mapfre.es/normativa/',
        accessibility: 'https://www.mapfre.es/accesibilidad/',
        warnings: 'https://www.mapfre.es/advertencias/',
        ARCO: 'https://www.mapfre.es/lopd/',
        information_interest: 'https://www.mapfre.es/informacion-de-interes/',
        data_protection: 'https://www.mapfre.es/lopd/'
    }
};

export const SOCIAL_MEDIA_LINKS = {
    mobilemap: 'https://www.mapfre.es/movil/',
    instagram: 'https://www.instagram.com/mapfre_es/',
    facebook: 'https://es-es.facebook.com/MAPFRE.ES/',
    twitter: 'https://twitter.com/MAPFRE_ES',
    youtube: 'https://www.youtube.com/user/mapfretecuidamos',
    linkedin: 'https://www.linkedin.com/company/mapfre/'
};
